const HashIcon = ({ width = 24, height = 24, color = "white" }) => {
  return (
    <svg
      id="Layer_2"
      style={{ enableBackground: "new 0 0 32 32" }}
      version="1.1"
      viewBox="0 0 32 32"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      fill={color}
      height={height}
      width={width}>
      <g>
        <path d="M30,12.5c0.82813,0,1.5-0.67139,1.5-1.5S30.82813,9.5,30,9.5h-5.74921l1.29218-7.23633   c0.14551-0.81543-0.39746-1.59473-1.21289-1.74023c-0.80859-0.14404-1.59473,0.39697-1.74023,1.21289L21.20349,9.5h-8.08551   l1.29218-7.23633c0.14551-0.81543-0.39746-1.59473-1.21289-1.74023c-0.80664-0.14404-1.59375,0.39697-1.74023,1.21289L10.07068,9.5   H2c-0.82813,0-1.5,0.67139-1.5,1.5s0.67188,1.5,1.5,1.5h7.53497l-1.25,7H2c-0.82813,0-1.5,0.67139-1.5,1.5s0.67188,1.5,1.5,1.5   h5.74921l-1.29218,7.23633c-0.14551,0.81543,0.39746,1.59473,1.21289,1.74023c0.08887,0.01611,0.17773,0.02393,0.26563,0.02393   c0.71289,0,1.34473-0.51025,1.47461-1.23682L10.79651,22.5h8.08551l-1.29218,7.23633   c-0.14551,0.81543,0.39746,1.59473,1.21289,1.74023c0.08887,0.01611,0.17773,0.02393,0.26563,0.02393   c0.71289,0,1.34473-0.51025,1.47461-1.23682L21.92932,22.5H30c0.82813,0,1.5-0.67139,1.5-1.5s-0.67188-1.5-1.5-1.5h-7.53497l1.25-7   H30z M19.41779,19.5h-8.08557l1.25-7h8.08557L19.41779,19.5z" />
      </g>
    </svg>
  );
};

export default HashIcon;
